// Generic types for the shared component
export type BaseTagPickerProps = {
  onAddTag: (tag: string) => void;
  inputRef: React.RefObject<HTMLInputElement | null>;
  commonTags?: string[];
  recentTags: string[];
  selectedTags: string[];
};

export type TagPickerProps = BaseTagPickerProps & {
  tenantId?: string;
};

// Base type for rows that have tags
export type TaggedRow = {
  tags?: string[] | { id: string; name: string }[] | null;
  id: string;
};

// Simple update object type
export type EntityUpdate = {
  tags: string[];
  id: string;
};

export type ManageTagsFormDialogProps<T extends TaggedRow = TaggedRow> = {
  selectedRows: T[];
  getEntityId: (row: T) => string;
  tenantId?: string;
  onClose: () => void;
  onCloseConfirmation: () => void;
  confirm: () => void;
  open: boolean;
  withConfirmation?: boolean;
  showConfirmation: boolean;
  onSubmit: (updates: EntityUpdate[]) => Promise<void>;
  loading: boolean;
  entityName: string;
  localStorageKey: string;
  commonTags?: string[];
  TagPickerComponent: React.ComponentType<TagPickerProps>;
};

export enum TagType {
  NEW = "new", // Light green - newly added tags
  ALL = "all", // Blue - tags on all selected entities
  PARTIAL = "partial", // Gray - tags on some selected entities
}

export type TagInfo = {
  name: string;
  type: TagType;
  originallyPartial: boolean; // Track if tag was originally partial for demotion logic
};

export type ManageTagsFormState = {
  tagInput: string;
};

// State management types
export type TagState = {
  selectedTags: TagInfo[];
  removedTags: TagInfo[];
  initialSnapshot: TagInfo[];
  recentTags: string[];
};

export type TagAction =
  | {
      type: "INITIALIZE";
      payload: { selectedRows: any[]; recentTags: string[] };
    }
  | { type: "ADD_TAG"; payload: string }
  | { type: "REMOVE_TAG"; payload: string }
  | { type: "RESTORE_TAG"; payload: string }
  | { type: "PROMOTE_TAG"; payload: string }
  | { type: "REMOVE_ALL_TAGS" };
